var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77214 15.1556C10.3105 15.1556 11.7246 14.6264 12.853 13.7489L16.5163 17.4123L17.6946 16.2339L14.0313 12.5706C14.9096 11.4414 15.4388 10.0273 15.4388 8.48893C15.4388 4.8131 12.448 1.82227 8.77214 1.82227C5.0963 1.82227 2.10547 4.8131 2.10547 8.48893C2.10547 12.1648 5.0963 15.1556 8.77214 15.1556ZM8.77214 3.48893C11.5296 3.48893 13.7721 5.73143 13.7721 8.48893C13.7721 11.2464 11.5296 13.4889 8.77214 13.4889C6.01464 13.4889 3.77214 11.2464 3.77214 8.48893C3.77214 5.73143 6.01464 3.48893 8.77214 3.48893Z",
    fill: "#C10037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94964 7.31083C10.2655 7.6275 10.4396 8.04583 10.4396 8.48917H12.1063C12.1063 7.60167 11.7596 6.765 11.128 6.1325C9.8663 4.8725 7.6788 4.8725 6.41797 6.1325L7.59464 7.3125C8.22797 6.68083 9.31964 6.6825 9.94964 7.31083Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f5390fcae5c7f44a7166945b7d0a4eb5.svg";
export { ForwardRef as ReactComponent };